import React from "react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // Optionally log to a monitoring service
    // console.error("ErrorBoundary caught: ", error, errorInfo);
  }

  handleReload = () => {
    this.setState({ hasError: false, error: null });
    window.location.href = "/";
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-[60vh] flex items-center justify-center">
          <div className="max-w-xl bg-white/5 border border-white/10 rounded-lg p-6 text-white text-center">
            <h2 className="text-xl font-semibold mb-2">Something went wrong</h2>
            <p className="text-white/70 text-sm mb-4">
              We hit a rendering error while loading this view.
            </p>
            {this.state.error && (
              <pre className="text-left whitespace-pre-wrap text-xs bg-black/40 rounded p-3 mb-4 max-h-48 overflow-auto">
                {String(this.state.error)}
              </pre>
            )}
            <button onClick={this.handleReload} className="bg-cyan-700 hover:bg-cyan-600 text-white rounded px-4 py-2">
              Go to Overview
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}